import addExtensionsToRegistry from './add-extensions-to-registry';

export default {
  addExtensionsToRegistry,
};
